module.exports = __webpack_public_path__ + "static/audio/ambiance.9a92c5f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/sound/audio/ambiance.mp3
// module id = cAsU
// module chunks = 0